module.exports = __webpack_public_path__ + "media/images/order/tomferry-logo-darkblue-lg-3d3b679d97794ed0be46109559a3f84c.png";